<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 13:38:32
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 14:34:16
-->
<!-- 获取车辆身份 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"carCode":"测AKE1997","type":0,"monthId":10},
            responseCode: {"data":{"canBuy":true},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查看月票是否预选购买",
                t_url: this.commonUrls.test+"checkMonthTicketAppointment",
                p_url: this.commonUrls.prod+"checkMonthTicketAppointment",
                precondition: "无",
                fitSystem: "云停车场,传统车场vems,路边车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'monthBillId', info2: '否', info3: 'Long', info4: '月票订单ID(退款必填)' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '类型(0：能否新增，1：能否退款)' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'isCanBuy', info2: '是', info3: 'Boolean', info4: 'false\true(能购买，能退款)' },
                        
					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/checkMonthTicketAppointment.vue